module.exports = __webpack_public_path__ + "1039873a3c9d862e07b91a101ca27e6a.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/spacemarines-vignette-preview-320.jpg
// module id = 542
// module chunks = 0